// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 453 ? "eef9e134" : chunkId) + "." + {"24":"48ad6a20c5c2b853","54":"35908394b9f89e3b","74":"1a22eab6ed50b0c3","178":"6556961d1dfc90f1","401":"728ea532c8e2f030","453":"7e9867cf4fa5ef64","640":"dd3b416293bff626","701":"b5555051974d29ea","754":"9a572a6e55e120cb"}[chunkId] + ".js";
};